<p mat-dialog-title class="mb-8 text-lg font-bold">
    {{ 'forms.accept-terms-form-title' | transloco }}
</p>
<mat-dialog-content class="flex flex-col gap-4 pt-8">
    <p class="max-w-lg px-2 py-4">
        {{
            'forms.accept-terms-form-content'
                | transloco : { date: (data.lastUpdated | date : 'shortDate') }
        }}
    </p>
    <app-legal-and-newsletter-checkbox (formChanges)="termsFormsChange($event)" />
</mat-dialog-content>
<mat-dialog-actions class="flex !justify-center">
    <button
        mat-button
        (click)="save()"
        class="rounded-s mat-primary m-4 !text-brand1 hover:!bg-saveBtnHover"
        [class.!text-gray]="!termsForms.valid"
        [disabled]="!termsForms.valid"
    >
        {{ 'forms.accept-terms-form-button' | transloco }}
    </button>
</mat-dialog-actions>
